import React from "react";
import { DefaultProfile } from "@/images";

const MobileCTA = ({ agent }) => (
  <div className="abr-mobile-cta" role="complementary" aria-label={`Contact ${agent.fullName}`}>
    <img src={agent.photoUrl || DefaultProfile} alt="" />
    <span className="abr-mc-name">{agent.fullName}</span>
    <a href={`tel:${agent.phoneTel}`}>Call</a>
  </div>
);

export default MobileCTA;
